<template>
  <div>
    <v-card-title class="text-size-5 pl-5">
      公開 / 非公開設定
    </v-card-title>
    <v-divider />

    <v-card-text class="pt-8">
      <v-row
        no-gutters
        justify="center"
        class="text-size-2 text-left">
        <ul>
          <li><b>"{{ label.public }}"</b> にすることで、他のユーザに写真と場所を公開することができます。</li>
          <li>パートナーに対して非公開にすることはできません。</li>
          <li>他のユーザが見ることができるのは、<b>都道府県と場所、写真のみ</b>です。</li>
          <li>公開設定にしても、LINEの情報が他のユーザに見られることはありません。</li>
        </ul>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import labelString from '../../data/labelString';

export default {
  data() {
    return {
      label: {
        public: labelString.public,
      },
    };
  },
};
</script>